// loader.component.ts
import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoaderService } from '../services/loader.service';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule],
  template: `
    <div class="loader-backdrop" *ngIf="loader.isLoading()">
      <mat-progress-spinner mode="indeterminate" diameter="60"> </mat-progress-spinner>
    </div>
  `,
  styles: [
    `
      .loader-backdrop {
        position: fixed;
        inset: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(0, 0, 0, 0.35);
        z-index: 10000; /* per sobre de tot el Material */
      }
    `,
  ],
})
export class LoaderComponent {
  loader = inject(LoaderService);
}
